import { RouterView, type RouterOptions } from "vue-router";
import EntityAudits from "@/components/EntityAudits.vue";
import { EntityDocuments } from "@modernary/mui/components/document";

const names = {
  inspections: "Inspection.Inspections",
  list: "Inspection.InspectionList",
  new: "Inspection.InspectionNew",
  base: "Inspection.InspectionBase",
  view: "Inspection.InspectionView",
  edit: "Inspection.InspectionEdit",
  complete: "Inspection.InspectionComplete",
  schedule: "Inspection.InspectionSchedule",
  affiliations: "Inspection.InspectionAffiliations",
  affiliationEdit: "Inspection.InspectionAffiliationEdit",
  affiliationNew: "Inspection.InspectionAffiliationNew",
  documents: "Inspection.InspectionDocuments",
  documentEdit: "Inspection.InspectionDocumentEdit",
  documentNew: "Inspection.InspectionDocumentNew",
  audit: "Inspection.InspectionAudit",
};

export { names as inspectionRouteNames };

const inspectionRoutes: RouterOptions["routes"] = [
  {
    path: "/inspections",
    name: names.inspections,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Inspections", lookupGroups: ["InspectionType", "InspectionStatus"] },
        component: () => import("@/views/inspection/InspectionList.vue"),
      },
      {
        path: "new/:facilitySiteId(\\d+)?",
        component: () => import("@/views/inspection/InspectionBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Inspection", isNew: true },
            component: () => import("@/views/inspection/InspectionEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/inspection/InspectionBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Inspection View" },
            component: () => import("@/views/inspection/InspectionView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Inspection Edit", isForm: true },
            component: () => import("@/views/inspection/InspectionEdit.vue"),
          },
          {
            path: "complete",
            name: names.complete,
            meta: { title: "Complete Inspection", isForm: true },
            component: () => import("@/views/inspection/InspectionComplete.vue"),
          },
          {
            path: "schedule/:facilitySiteId(\\d+)",
            name: names.schedule,
            meta: { title: "Schedule Next Inspection", isForm: true },
            component: () => import("@/views/inspection/InspectionSchedule.vue"),
          },
          {
            path: "affiliations",
            name: names.affiliations,
            meta: { title: "Inspection Affiliations" },
            component: () => import("@/views/inspection/InspectionAffiliations.vue"),
          },
          {
            path: "affiliations/:affiliationId(\\d+)/:entityType(person)",
            name: names.affiliationEdit,
            meta: { title: "Edit Inspection Site Affiliation", isForm: true },
            component: () => import("@/views/inspection/InspectionAffiliation.vue"),
          },
          {
            path: "affiliations/new",
            name: names.affiliationNew,
            meta: { title: "Create Inspection Site Affiliation", isForm: true },
            component: () => import("@/views/inspection/InspectionAffiliation.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Inspection Site Documents" },
            component: {
              render: () => <EntityDocuments idField="inspectionId" routeNamePrefix="Inspection.InspectionDocument" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Edit Inspection Document", isForm: true },
            component: () => import("@/views/inspection/InspectionDocument.vue"),
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Create Inspection Document", isForm: true },
            component: () => import("@/views/inspection/InspectionDocuments.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Inspection Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="Inspection" />,
            },
          },
          // {
          //   path: "notes",
          //   name: "InspectionNotes",
          //   meta: { title: "Inspection Site Internal Notes" },
          //   component: () => import("@/views/inspection/InspectionNotes.vue"),
          // },
          // {
          //   path: "notes/:annotationId(\\d+)",
          //   name: "InspectionNoteEdit",
          //   meta: { title: "Edit Inspection Site Internal Note", isForm: true },
          //   component: () => import("@/views/inspection/InspectionNote.vue"),
          // },
          // {
          //   path: "notes/new",
          //   name: "InspectionNoteNew",
          //   meta: { title: "Create Inspection Site Internal Note", isForm: true },
          //   component: () => import("@/views/inspection/InspectionNote.vue"),
          // },
          // {
          //   path: "disposalReports",
          //   name: "InspectionDisposalReports",
          //   meta: { title: "Inspection Site Disposal Reports" },
          //   component: () => import("@/views/inspection/DisposalReportChildList.vue"),
          // },
          // {
          //   path: "users",
          //   name: "InspectionUsers",
          //   meta: { title: "Inspection Site Users" },
          //   component: () => import("@/views/inspection/InspectionUsers.vue"),
          // },
          // {
          //   path: "users/new",
          //   name: "InspectionUserNew",
          //   meta: { title: "Add Inspection Site User", isForm: true },
          //   component: () => import("@/views/inspection/InspectionUser.vue"),
          // },
        ],
      },
    ],
  },
];
export default inspectionRoutes;
